import { css } from 'lit';
export const hostStyles = css `
  :host {
    display: block;

    /* Icon Sizes */
    --zui-icon-size-8: 8px;
    --zui-icon-size-12: 12px;
    --zui-icon-size-16: 16px;
    --zui-icon-size-24: 24px;
    --zui-icon-size-32: 32px;
    --zui-icon-size-40: 40px;
    --zui-icon-size-48: 48px;
    --zui-icon-size-64: 64px;
    --zui-icon-size-72: 72px;
    --zui-icon-size-80: 80px;
  }
  :host([hidden]) {
    display: none;
  }
`;
